var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":"","page-sizes":[ 10 , 20 , 30 , 40 , 50 ],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total,"current-page":_vm.currentPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }